import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import type { Student } from '../api/students';

interface ConfirmDismissDialogProps {
  open: boolean;
  student: Student | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDismissDialog({
  open,
  student,
  onConfirm,
  onCancel,
}: ConfirmDismissDialogProps) {
  if (!student) return null;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Dismissal</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to dismiss this student?
        </DialogContentText>
        <Stack spacing={1} sx={{ mt: 2 }}>
          <Typography variant="body1">
            <strong>Name:</strong> {student.first_name} {student.last_name}
          </Typography>
          <Typography variant="body1">
            <strong>Grade:</strong> {student.grade}
          </Typography>
          <Typography variant="body1">
            <strong>Going home by:</strong> {student.pickup_type === 'car' ? 'Car Line' : 'Walker'}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="danger" autoFocus>
          Dismiss Student
        </Button>
      </DialogActions>
    </Dialog>
  );
}
